import { render, staticRenderFns } from "./DeactivateResourcesConfirmationModal.vue?vue&type=template&id=53c98732&scoped=true&"
import script from "./DeactivateResourcesConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./DeactivateResourcesConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivateResourcesConfirmationModal.vue?vue&type=style&index=0&id=53c98732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c98732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c98732')) {
      api.createRecord('53c98732', component.options)
    } else {
      api.reload('53c98732', component.options)
    }
    module.hot.accept("./DeactivateResourcesConfirmationModal.vue?vue&type=template&id=53c98732&scoped=true&", function () {
      api.rerender('53c98732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/DeactivateResourcesConfirmationModal.vue"
export default component.exports